import { render, staticRenderFns } from "./left-list.vue?vue&type=template&id=45bae690&scoped=true&"
import script from "./left-list.vue?vue&type=script&lang=ts&"
export * from "./left-list.vue?vue&type=script&lang=ts&"
import style0 from "./left-list.vue?vue&type=style&index=0&id=45bae690&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bae690",
  null
  
)

export default component.exports